import React, { useState } from 'react'
import './Responsibilities.scss'
import { Container, Row, Col } from 'react-bootstrap'
import { isMobile } from 'react-device-detect'
import Collapse from '@kunukn/react-collapse'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import {animateScroll as scroll, scroller} from 'react-scroll'

import Element from './Responsibility/Element'
const Responsibilities = ({ responsibilities }) => {
  const [isCollapseOpen, changeCollapseState] = useState(false)

  const scrollTo = () => {
    scroller.scrollTo('offer', {
      duration: 800,
      delay: 0,
      offset:-50,
      smooth: 'easeInOutQuart'
    })
  }

  return (
    <Container className="responsibilities" id="offer">
      <Row className="responsibilities__title">
        <Col>
          <h1>Usługi</h1>
        </Col>
      </Row>
      {!isMobile ? (
        <Row className="responsibilities__item">
          {responsibilities.map((item, index) => (
            <Element text={item.text} icon={item.icon} key={`Responsibilities${index}`} />
          ))}
        </Row>
      ) : (
        <Row className="responsibilities__item">
          {responsibilities.slice(0, 2).map((item, index) => (
            <Element text={item.text} icon={item.icon} key={`Responsibilities${index}`} />
          ))}
          <Col md={12} className="element">
            <Collapse isOpen={isCollapseOpen}>
              <Row className="responsibilities__item">
                {responsibilities.slice(2).map((item, index) => (
                  <Element text={item.text} icon={item.icon} key={`Responsibilities${index}`} />
                ))}
                <Col md={12} className="element">
                  <button
                    className="responsibilities__collapseButton"
                    onClick={() => {changeCollapseState(!isCollapseOpen); scrollTo()}}
                  >
                    Mniej
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      className="responsibilities__collapseButton__icon"
                    />
                  </button>
                </Col>
              </Row>
            </Collapse>
          </Col>
          {!isCollapseOpen && (
            <Col md={12} className="element">
              <button
                className="responsibilities__collapseButton"
                onClick={() => changeCollapseState(!isCollapseOpen)}
              >
                Więcej
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="responsibilities__collapseButton__icon"
                />
              </button>
            </Col>
          )}
        </Row>
      )}
    </Container>
  )
}

export default Responsibilities
